<script>
    import {Decimal} from 'decimal.js';

    export default {
        name: "ProductUpdateInitial",
        props:['initial'],
        data() {
            return {
                initialAttributes: [],
                initialManufacturerAttributeName: 'proizvoditel'
            }
        },
        methods: {
            setInitialData() {
                /*override in step to process initial data*/
            },
            setAttributes() {
                if(!this.initial || !this.initial.attributes) return false;

                this.initialAttributes = this.initial.attributes;
            },
            setDescription() {
                if(!this.initial || !this.initial.description_ru || !this.initial.description_ua) return false;

                this.descriptionRu = this.initial.description_ru;
                this.descriptionUa = this.initial.description_ua;
            },
            setMainInfoInitial() {
                if(!this.initial) return false;

                if(this.initial.categoryParent) {
                    this.stepData.mainCategory = this.initial.categoryParent;
                    this.changeMainCategory();
                }

                if(this.initial.category) {
                    this.stepData.category = this.initial.category;
                    this.changeCategory();
                }

                this.stepData.productNameRu = this.initial.name_ru || null;
                this.stepData.productNameUa = this.initial.name_ua || null;
                this.stepData.articleNumber = this.initial.articleNumber || null;
                this.stepData.initialImages = this.initial.images;

                if(this.initial.pack) {
                    this.stepData.packingType = {id: this.initial.pack.packID, name: this.initial.pack.packName};
                    this.stepData.packingQuantity = this.initial.pack.value;
                    this.stepData.quantityUnits = {id: this.initial.pack.unitID, name: this.initial.pack.unitName};
                    this.stepData.minValueQuantity = this.initial.pack.minValue || null;
                    this.stepData.packLength = this.initial.pack.length;
                    this.stepData.packWidth = this.initial.pack.width;
                    this.stepData.packHeight = this.initial.pack.height;
                    this.stepData.packWeight = this.initial.pack.weight;
                }

                if(this.initial.price) {
                    this.stepData.currency = {id: this.initial.price.currencyID, name: this.initial.price.currencyName};
                    this.stepData.price = this.initial.price.value || null;
                    this.stepData.withNds = this.initial.price.withNds;
                    this.stepData.discountPercent = this.initial.price.discount;
                    this.discountPrice = new Decimal(this.stepData.price*(1-this.stepData.discountPercent/100)).toDecimalPlaces(2);
                }

                if(this.initial.manufacturer) {
                    this.stepData.manufacturer = {
                        id: this.initial.manufacturer.valueID,
                        system_name: this.initial.manufacturer.attributeSystemName,
                        name: this.initial.manufacturer.attributeName,
                    };
                }
            },
            setPayments() {
                if(!this.initial) return false;

                this.payments = this.initial.paymentWays.map(item => item.id);
            }
        },
        watch: {
            initial: {
                handler() {
                    this.setInitialData();
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>
